import React from 'react';
import { Checkbox, Tooltip } from 'antd';
import { Icon } from '@common/components';

type Props = {
  title: string;
  onClick: () => void;
  checked?: boolean;
  blocked?: boolean;
};

export const RateCheckbox = ({
  title,
  checked,
  onClick,
  blocked = false,
}: Props) => (
  <Checkbox checked={checked} onClick={onClick} disabled={blocked}>
    {!checked && (
      <Tooltip title={title}>
        <Icon icon="flag" kind="solid" color="coralLighter" />
      </Tooltip>
    )}
  </Checkbox>
);
